import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateLegalsResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const associateLegals = {
    record(data: typeof Requests.AssociateLegals.Record.Input) {
        return post<typeof data, AssociateLegalsResponseTypes.Record>(
            `/associate-legals/record`,
            data,
        );
    },
    create(data: typeof Requests.AssociateLegals.Create.Input) {
        return post<typeof data>(`/associate-legals/create`, data);
    },
    delete(id: string) {
        return postEmpty(`/associate-legals/delete/${id}`);
    },
    obtain(id: string) {
        return get<AssociateLegalsResponseTypes.Obtain>(`/associate-legals/obtain/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateLegals.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate-legals/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
